import { useIntersectionObserver } from 'hooks';
import { useCallback } from 'react';

export const useDialogScrollNavigation = () => {
  const [topAnchorRef, isTopVisible] = useIntersectionObserver({
    initialIsIntersecting: true,
  });

  const [bottomAnchorRef, isBottomVisible] = useIntersectionObserver({
    initialIsIntersecting: true,
  });

  const scrollTo = useCallback((direction: 'top' | 'bottom') => {
    const element = document.getElementById('dialog-overlay');

    element?.scrollTo({
      top: direction === 'top' ? 0 : element.scrollHeight,
      behavior: 'smooth',
    });
  }, []);

  return {
    topAnchorRef,
    bottomAnchorRef,
    isTopVisible,
    isBottomVisible,
    scrollTo,
  };
};
